<style lang="scss" rel="stylesheet/scss">
@import "@/scss/color";
@import "@/scss/font";

.module.three-boxes {
    h1 {
        width: 100%;
    }

    h2 {
        @extend .boxes-header;
    }

    .boxes {
        display: flex;
        justify-content: center;
        margin-bottom: 10px;
        width: 100%;
    }

    .box {
        display: flex;
        width: 100%;
        max-width: 30%;

        min-height: 180px;

        flex-direction: column;
        justify-content: flex-start;
        align-items: center;

        background-color: $grey;
        border-radius: 10px;
        text-align: center;
        padding: 20px 32px;
        margin-right: 30px;

        font-size: 12px;

        > * {
            width: 100%;
        }

        h2 {
            font-size: 30px;
        }
    }

    .box:last-child {
        margin-right: 0;
    }

    @media (max-width: 767px) {
        .boxes {
            flex-wrap: wrap;
        }

        .box {
            max-width: 400px;
            min-height: 128px;
            border-radius: 5px;
            padding: 10px 16px;
            margin-right: 0;
            margin-bottom: 10px;
        }
    }
}
</style>

<template>
    <div class="module three-boxes">
        <h1>
            <content-item :config="content.header"></content-item>
        </h1>

        <div class="boxes">
            <div class="box">
                <h2>
                    <content-item :config="content.box_header_1"></content-item>
                </h2>
                <content-item :config="content.box_content_1"></content-item>
            </div>
            <div class="box">
                <h2>
                    <content-item :config="content.box_header_2"></content-item>
                </h2>
                <content-item :config="content.box_content_2"></content-item>
            </div>
            <div class="box">
                <h2>
                    <content-item :config="content.box_header_3"></content-item>
                </h2>
                <content-item :config="content.box_content_3"></content-item>
            </div>
        </div>

        <div class="buttons">
            <step-button
                @click="previousSection()"
                direction="left"
                v-if="hasPrevious"
            ></step-button>
            <step-button @click="nextSection()" v-if="hasNext"></step-button>
        </div>
    </div>
</template>

<script type="text/babel">
import ModuleMixin from "../ModuleMixin";
export default {
    name: "module-three-boxes",
    data() {
        return {};
    },
    mounted() {},
    mixins: [ModuleMixin]
};
</script>
